import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { isAvailableForBookingDuration } from "@/utils/slotAvailability";

import { useValidDurationsNode$key } from "./__generated__/useValidDurationsNode.graphql";

export const useValidDurations = (
  nodeRef: useValidDurationsNode$key | null
) => {
  const timeSlot = useFragment(useValidDurationsFragmentString, nodeRef);

  return (
    timeSlot?.endSlotOptions?.edges
      ?.filter((e) => isAvailableForBookingDuration(e?.node?.availability))
      .map((e) => ({
        durationMins: e?.durationMins ?? 0,
        allowedPlayerCounts:
          e?.allowedPlayerCounts?.flatMap((a) => (a ? a : [])) ?? [],
        slotId: e?.node?.id ?? "",
      })) ?? []
  );
};

export const useValidDurationsFragmentString = graphql`
  fragment useValidDurationsNode on Node {
    ... on TimeSlot {
      endSlotOptions(
        bookingId: $bookingId
        bookingType: $bookingType
        memberId: $memberId
      ) {
        edges {
          durationMins
          allowedPlayerCounts
          node {
            id
            time
            availability
          }
        }
      }
    }
  }
`;
